import { showAddMedia } from '@components/add-media';
import { FilePickerOpts } from '@components/filepicker';
import { MinidocToolbarAction } from 'minidoc-editor';
import { Internationalize } from 'shared/intl';

interface Props {
  id?: string;
  compact?: boolean;
  onItemSelect?: () => void;
  triggerHTML?: string;
  intl: Internationalize;
  /**
   * When the editor is rendered somewhere public (e.g. a sales page), a file
   * picked from the media manager must serve to logged-out visitors. Mark it
   * public on pick, mirroring the inline upload's `isPublic` behavior.
   */
  isPublic?: boolean;
  accept?: string;
  uploadOpts?: FilePickerOpts;
  allowEmbed?: boolean;
}

export const LiteralIconImg = `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M5 8.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5zm9 .5l-2.519 4-2.481-1.96-4 5.96h14l-5-8zm8-4v14h-20v-14h20zm2-2h-24v18h24v-18z"/></svg>`;

export const toolbarDropdown = (props: Props): MinidocToolbarAction => {
  const { intl, onItemSelect, isPublic, accept, uploadOpts, allowEmbed } = props;
  const defaultTriggerHTML = `<svg
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
  </svg>
  ${props.compact ? '' : `<span class="hidden lg:inline-block ml-1.5">${intl('Add media')}</span>`}`;

  return {
    id: 'dd_insert',
    label: intl('Add media'),
    html: `<span class="inline-flex items-center px-2">${props.triggerHTML || defaultTriggerHTML}</span>`,
    run(t) {
      if (onItemSelect) {
        onItemSelect();
        return;
      }
      void showAddMedia(t, { intl, isPublic, accept, uploadOpts, allowEmbed });
    },
  };
};
